import { createClient } from '@supabase/supabase-js';

// Use environment variables with fallbacks for development
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://pxkjapyvmswebsakchvh.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB4a2phcHl2bXN3ZWJzYWtjaHZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjE4Njg5NjQsImV4cCI6MjAzNzQ0NDk2NH0.7V1WjJONOGDhD2VtVtHMZnTfvrhxg6_JKbYmWI1Wprk';

export const supabase = createClient(supabaseUrl, supabaseKey);
